module.exports = __webpack_public_path__ + "static/media/developerSite.ea13f944.png";